export default __webpack_public_path__ + "static/media/dog-loading1.62563541.gif";